import { clsx } from 'clsx';

function Card({ className, children, ...props }) {
  return (
    <div
      className={clsx(
        'bg-surface rounded-lg border border-border shadow-sm',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

function CardHeader({ className, children, ...props }) {
  return (
    <div
      className={clsx('px-5 py-4 border-b border-border', className)}
      {...props}
    >
      {children}
    </div>
  );
}

function CardBody({ className, children, ...props }) {
  return (
    <div className={clsx('px-5 py-5', className)} {...props}>
      {children}
    </div>
  );
}

function CardFooter({ className, children, ...props }) {
  return (
    <div
      className={clsx('px-5 py-3 border-t border-border', className)}
      {...props}
    >
      {children}
    </div>
  );
}

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
